import apiClient from "./middleware";

export type AssetExportRowMode = "assets" | "hierarchy";
export type AssetExportScope = "asset" | "root" | "child" | "grandchild";
export type AssetExportField =
  | "asset_id"
  | "asset_type"
  | "title"
  | "artist"
  | "isrc"
  | "upc"
  | "label"
  | "writer"
  | "custom_id"
  | "description"
  | "labels"
  | "parent_asset_id"
  | "child_asset"
  | "time_created"
  | "time_updated";

export interface AssetExportColumn {
  scope: AssetExportScope;
  field: AssetExportField;
}

export interface AssetScrapeCustomExportRequest {
  rowMode: AssetExportRowMode;
  columns: AssetExportColumn[];
}

function responseFilename(
  contentDisposition: string | undefined,
  fallback: string
): string {
  if (!contentDisposition) return fallback;
  const quoted = contentDisposition.match(/filename="([^"]+)"/i);
  if (quoted?.[1]) return quoted[1];
  const encoded = contentDisposition.match(/filename\*=UTF-8''([^;\s]+)/i);
  return encoded?.[1] ? decodeURIComponent(encoded[1]) : fallback;
}

export const assetScraperExportApi = {
  download: async (
    jobId: string,
    request: AssetScrapeCustomExportRequest
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await apiClient.post(
      `/scrapers/music-asset-scraper/jobs/${jobId}/export`,
      request,
      { responseType: "blob" }
    );
    const contentDisposition =
      (response.headers["content-disposition"] as string | undefined) ||
      (response.headers["Content-Disposition"] as string | undefined);
    return {
      blob: response.data as Blob,
      filename: responseFilename(
        contentDisposition,
        `scrape_custom_export_${jobId}.csv`
      ),
    };
  },
};
